/**
 * Breakpoint
 */

export const breakpoint = {
  xs: "0px",
  sm: "576px",
  md: "750px",
  lg: "992px",
  xl: "1200px",
  xxl: "1400px",
};
